import { View, Text, ScrollView, ImageBackground, Pressable } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import cupsData from '../cupsData';
import dr from './../datosReferenciales.json';
import transl from './../translations/transl'
import { useSelector } from 'react-redux';

let lang = 0;

const HallOfFame = () => {
  const navigation = useNavigation();

  useLayoutEffect(() => {
    navigation.setOptions({
        headerTitle: transl('HallOfFame.salonDeLa',lang)
    })
  }, []);

//receivedData
  const [value, setvalue] = useState('');
  const readValue = () => {
    AsyncStorage.getItem('equipos')
    .then((value)=> {
      setvalue(value)
    })
  }
  readValue()

  lang = dr.idiomas[useSelector((state) => state.language)].value

  return (
    <View style={{flex:1}}>
      <ImageBackground source={require('./../img/background5.png')} resizeMode="cover" style={{flex:1}}>
        <View>
          {/* <View style={{flexDirection:"row", paddingHorizontal:10, paddingVertical: 10,justifyContent: 'center', alignItems: 'center',backgroundColor:'#fff'}}>
            <View style={[{flex:1,marginRight:0,justifyContent:'center'}, GlobalStyles.buttonShadow]}>
              <Pressable
                style={GlobalStyles.buttonMain}
                onPress={() => {}}>
                <Text style={GlobalStyles.textForButtonMain}>{transl('HallOfFame.Copas',lang)}</Text>
              </Pressable>
            </View>
            <View style={[{flex:1,marginHorizontal:5,justifyContent:'center'}, GlobalStyles.buttonShadow]}>
              <Pressable
                style={GlobalStyles.buttonMain}
                onPress={() => {}}>
                <Text style={GlobalStyles.textForButtonMain}>{transl('HallOfFame.Trofeos',lang)}</Text>
              </Pressable>
            </View>
            <View style={[{flex:1,marginLeft:0}, GlobalStyles.buttonShadow]}>
              <Pressable
                style={GlobalStyles.buttonMain}
                onPress={() => {}}>
                <Text style={GlobalStyles.textForButtonMain}>{transl('HallOfFame.Fecha',lang)}</Text>
              </Pressable>
            </View>
          </View> */}
          <View>
            {displayInfo(value)}
          </View>
        </View>
      </ImageBackground>
    </View>
  )

  function displayInfo(data){
    if(data === undefined || !data) return
    data = data != null ? JSON.parse(data) : null

    const trophies = data.others.trophies
    let allTrophies = [];
    for(let i = 0; i < trophies.length; i++){
      allTrophies.push(cupsData(trophies[i].cupType ? trophies[i].cupType : [trophies[i].name,trophies[i].description],trophies[i].icon,trophies[i].season,trophies[i].date ? trophies[i].date : 0,lang,(trophies[i].player && trophies[i].age) ? [trophies[i].player,trophies[i].age] : []))
    }

    if(allTrophies.length==0){
      allTrophies.push(<ScrollView contentContainerStyle={{ flex: 1, justifyContent: 'center' }}><View style={{paddingHorizontal:50}}><Text style={{fontSize:22,textAlign:'center'}}>{transl('HallOfFame.aunNoHas',lang)}</Text></View></ScrollView>)
    } else allTrophies = allTrophies.reverse()

    return <ScrollView contentContainerStyle={{ flexGrow: 1 }}>{allTrophies}</ScrollView>
  }
}

export default HallOfFame